export const messages = {
  en: {
    questionAnswerManage: {
      search: {
        title: 'Search Conditions',
        qaName: 'Please enter questionnaire name'
      },
      list: {
        title: 'Questionnaire Survey'
      },
      table: {
        qaName: 'Questionnaire Name',
        validity: 'Validity Period',
        voteCount: 'Total/Completed',
        score: 'Score',
        state: 'Status',
        createTime: 'Create Time'
      },
      state: {
        published: 'Published',
        unpublished: 'Unpublished'
      },
      button: {
        result: 'Result',
        detail: 'Detail',
        publish: 'Publish'
      },
      edit: {
        title: 'Edit Questionnaire',
        qaType: 'Questionnaire Type',
        qaTypePlaceholder: 'Required, please select questionnaire type',
        qaType1: 'Owner Questionnaire',
        qaType3: 'Owner Voting',
        qaType4: 'Staff Voting',
        qaName: 'Name',
        qaNamePlaceholder: 'Required, please enter name',
        startTime: 'Start Time',
        startTimePlaceholder: 'Required, please enter start time',
        endTime: 'End Time',
        endTimePlaceholder: 'Required, please enter end time',
        content: 'Content',
        contentPlaceholder: 'Optional, please enter content',
        remark: 'Remark',
        remarkPlaceholder: 'Optional, please enter remark',
        photos: 'Photos'
      },
      delete: {
        title: 'Confirm Operation',
        confirmText: 'Are you sure to delete this questionnaire?'
      },
      publish: {
        title: 'Publish Questionnaire',
        qaName: 'Name',
        tip: 'Reminder',
        tipText: 'After publishing, it cannot be modified again. Please confirm before publishing!',
        notifyWay: 'Notification Method',
        notifyWayPlaceholder: 'Required, please select notification method',
        notifyWay1: 'SMS',
        notifyWay2: 'WeChat Message',
        notifyWay3: 'No Notification',
        button: 'Publish'
      },
      validate: {
        qaType: 'Questionnaire type is required',
        qaName: 'Questionnaire name is required',
        qaNameMax: 'Questionnaire name is too long',
        startTime: 'Start time is required',
        endTime: 'End time is required',
        notifyWay: 'Notification method is required'
      },
      message: {
        updateSuccess: 'Update successfully',
        updateError: 'Update failed',
        deleteSuccess: 'Delete successfully',
        deleteError: 'Delete failed',
        publishSuccess: 'Publish successfully',
        publishError: 'Publish failed',
        fetchError: 'Failed to fetch data'
      }
    },
    uploadImage: {
      validate: {
        imageType: 'Only image files are allowed',
        imageSize: 'Image size cannot exceed 2MB'
      },
      message: {
        uploadError: 'Image upload failed'
      }
    }
  },
  zh: {
    questionAnswerManage: {
      search: {
        title: '查询条件',
        qaName: '请输入问卷名称'
      },
      list: {
        title: '问卷调研'
      },
      table: {
        qaName: '问卷名称',
        validity: '有效期',
        voteCount: '总问卷/已问卷',
        score: '得分',
        state: '状态',
        createTime: '创建时间'
      },
      state: {
        published: '已发布',
        unpublished: '待发布'
      },
      button: {
        result: '结果',
        detail: '明细',
        publish: '发布'
      },
      edit: {
        title: '修改问卷信息',
        qaType: '问卷类型',
        qaTypePlaceholder: '必填，请选择问卷类型',
        qaType1: '业主问卷',
        qaType3: '业主投票',
        qaType4: '员工投票',
        qaName: '名称',
        qaNamePlaceholder: '必填，请填写名称',
        startTime: '开始时间',
        startTimePlaceholder: '必填，请填写开始时间',
        endTime: '结束时间',
        endTimePlaceholder: '必填，请填写结束时间',
        content: '内容',
        contentPlaceholder: '选填，请填写内容',
        remark: '备注',
        remarkPlaceholder: '选填，请填写备注',
        photos: '图片'
      },
      delete: {
        title: '请确认您的操作',
        confirmText: '确定删除问卷信息'
      },
      publish: {
        title: '发布',
        qaName: '名称',
        tip: '温馨提示',
        tipText: '发布后将无法再次修改，请确认无误后再发布！',
        notifyWay: '通知方式',
        notifyWayPlaceholder: '必填，请选择通知方式',
        notifyWay1: '短信',
        notifyWay2: '微信消息',
        notifyWay3: '不通知',
        button: '发布'
      },
      validate: {
        qaType: '问卷类型不能为空',
        qaName: '问卷名称不能为空',
        qaNameMax: '问卷名称太长',
        startTime: '开始时间不能为空',
        endTime: '结束时间不能为空',
        notifyWay: '通知方式不能为空'
      },
      message: {
        updateSuccess: '修改成功',
        updateError: '修改失败',
        deleteSuccess: '删除成功',
        deleteError: '删除失败',
        publishSuccess: '发布成功',
        publishError: '发布失败',
        fetchError: '获取数据失败'
      }
    },
    uploadImage: {
      validate: {
        imageType: '只能上传图片文件',
        imageSize: '图片大小不能超过2MB'
      },
      message: {
        uploadError: '图片上传失败'
      }
    }
  },
  'zh-TW': {
    questionAnswerManage: {
      search: {
        title: '查詢條件',
        qaName: '請輸入問卷名稱'
      },
      list: {
        title: '問卷調研'
      },
      table: {
        qaName: '問卷名稱',
        validity: '有效期',
        voteCount: '總問卷/已問卷',
        score: '得分',
        state: '狀態',
        createTime: '創建時間'
      },
      state: {
        published: '已發布',
        unpublished: '待發布'
      },
      button: {
        result: '結果',
        detail: '明細',
        publish: '發布'
      },
      edit: {
        title: '修改問卷信息',
        qaType: '問卷類型',
        qaTypePlaceholder: '必填，請選擇問卷類型',
        qaType1: '業主問卷',
        qaType3: '業主投票',
        qaType4: '員工投票',
        qaName: '名稱',
        qaNamePlaceholder: '必填，請填寫名稱',
        startTime: '開始時間',
        startTimePlaceholder: '必填，請填寫開始時間',
        endTime: '結束時間',
        endTimePlaceholder: '必填，請填寫結束時間',
        content: '內容',
        contentPlaceholder: '選填，請填寫內容',
        remark: '備註',
        remarkPlaceholder: '選填，請填寫備註',
        photos: '圖片'
      },
      delete: {
        title: '請確認您的操作',
        confirmText: '確定刪除問卷信息'
      },
      publish: {
        title: '發布',
        qaName: '名稱',
        tip: '溫馨提示',
        tipText: '發布後將無法再次修改，請確認無誤後再發布！',
        notifyWay: '通知方式',
        notifyWayPlaceholder: '必填，請選擇通知方式',
        notifyWay1: '短信',
        notifyWay2: '微信消息',
        notifyWay3: '不通知',
        button: '發布'
      },
      validate: {
        qaType: '問卷類型不能為空',
        qaName: '問卷名稱不能為空',
        qaNameMax: '問卷名稱太長',
        startTime: '開始時間不能為空',
        endTime: '結束時間不能為空',
        notifyWay: '通知方式不能為空'
      },
      message: {
        updateSuccess: '修改成功',
        updateError: '修改失敗',
        deleteSuccess: '刪除成功',
        deleteError: '刪除失敗',
        publishSuccess: '發布成功',
        publishError: '發布失敗',
        fetchError: '獲取數據失敗'
      }
    },
    uploadImage: {
      validate: {
        imageType: '只能上傳圖片文件',
        imageSize: '圖片大小不能超過2MB'
      },
      message: {
        uploadError: '圖片上傳失敗'
      }
    }
  }
}
